import React from "react";

const GDPR = ({ onHandleLinksActiveClosed }) => {
  return (
    <main className="terms" onClick={onHandleLinksActiveClosed}>
      <div className="container">
        <div className="terms-top">
          <h2>General Data Protection Regulation</h2>
          <h4>OMEGASTREAM is fully committed to complying and helping you comply with the GDPR.</h4>
          <p>Effective at 20/03/2023</p>
        </div>
        <div className="terms-bottom">
          <div className="terms">
            <div className="cart-item">
              <h3>1. What is GDPR?</h3>
              <p className="sub-li">
              <a href="https://gdpr.eu/"
               target="_blank"
               rel="noopener noreferrer">
                General Data Protection Regulation (GDPR)
              </a> is a new EU regulation designed to harmonize data privacy 
                laws across Europe and enforce significantly stricter privacy regulations. It was designed 
                to protect user privacy better and reshape how organizations handle personal data.
              </p>
            </div>
            <div className="cart-item">
              <h3>2. Does it apply to me?</h3>
              <p className="sub-li">
                Due to the global nature of OMEGASTREAM, GDPR will likely affect you in some way, so we 
                advise all of our users to thoroughly study new GDPR regulations. OMEGASTREAM is fully 
                committed to helping you with compliance, so we are rolling out anonymity features 
                ensuring no user-identifiable data is collected or processed whenever possible.
              </p>
            </div>
            <div className="cart-item">
              <h3>3. Data Processor (OMEGASTREAM)?</h3>
              <p className="sub-li">
                OMEGASTREAM's CDN and all other services may be used only for lawful purposes. 
                Transmission, distribution, or storage of any material in violation of any
                applicable law or regulation is prohibited. This includes, without limitation, 
                any material protected by copyright, trademark, trade secret, or other intellectual
                property right used without proper authorization, and material that is obscene, defamatory,
                constitutes an illegal threat or violates export control laws.
              </p>
            </div>
            <div className="cart-item">
              <h3>4. Abuse of Our Service</h3>
              <p className="sub-li">
                OMEGASTREAM typically acts as a data processor, meaning we process data on your behalf. 
                OMEGASTREAM allows you to gather and temporarily store visitor log information such as 
                anonymized IP, web address, country code, and user agent for the purpose of analyzing, 
                processing, testing, and security. Additionally, our system stores either temporarily or 
                permanently file obtained from your website by our system manually uploaded by you.
              </p>
              <div style={{marginTop: '10px'}}></div>
              <p className="sub-li">
                In most cases, the data held and collected by OMEGASTREAM does not contain any 
                user-identifiable data. However, in some cases, depending on how you use OMEGASTREAM
                and how your website is structured, personal data may be collected from your users. 
                Such information includes hosting user-uploaded content and personal data that might
                be transmitted in the URL, User-Agent, or Referer headers of the HTTP protocol.
              </p>
            </div>
            <div className="cart-item">
              <h3>5. Data Controller (You)</h3>
              <p className="sub-li">
                As a customer of OMEGASTREAM, you typically act as a data controller. This means you 
                determine if, why, and for how long data will be stored on our system. Our system 
                provides ways to process, store and aggregate the stored information. If you are 
                storing personal data on OMEGASTREAM, it is your duty as a controller to demonstrate 
                the same level of GDPR compliance.
              </p>
              <div style={{marginTop: '10px'}}></div>
              <p className="sub-li">
                While uncommon, OMEGASTREAM also provides a way to block users from the EU from 
                accessing your content altogether by using our traffic manager tools if you 
                do not wish to serve users from the European Union.
              </p>
            </div>
            <div className="cart-item">
              <h3>6. Data Processing Agreement (DPA)</h3>
              <p className="sub-li">
                Typically, OMEGASTREAM does not collect, store or distribute information that 
                could be used in any way to identify a user or contain their personal information. 
                If you believe that you process personal data on the OMEGASTREAM platform, this 
                qualifies you as a data processor, and you will be required by law to complete 
                a Data Processing Agreement (DPA). You can easily locate the DPA within your OMEGASTREAM panel.
              </p>
            </div>
            <div className="cart-item">
              <h3>7. How does OMEGASTREAM comply with GDPR?</h3>
              <p className="sub-li">
                OMEGASTREAM is fully committed to complying with the GDPR. We have overhauled our user 
                Privacy & Data policy and taken steps to ensure no personally identifiable data is 
                stored from your users that access your services through OMEGASTREAM by anonymizing any 
                data that could be used to directly or indirectly identify a user. We are also signing 
                the Data Processing Agreements with our partners and carefully overviewing that they take 
                the required privacy measures over the data shared or stored on their platforms.
              </p>
            </div>
            <div className="cart-item">
              <h3>8. Video on demand</h3>
              <p className="sub-li">
                  OMEGASTREAAM does not process or store permanently identifiable information. However, 
                  it can send back information about the stream quality, errors, buffering metrics, etc.,
                  to ensure good performance. Additionally, the iframe might ping various OMEGASTREAM CDN 
                  servers globally anonymously to collect performance statistics which are used to 
                  automatically adjust routing logic and optimize performance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default GDPR;
